import React, { useEffect, useState } from 'react';
import { Button } from 'modules/ui';
import Collapsible from './Collapsible';
import styles from './CollapsibleWithButton.module.scss';

export default function CollapsibleWithButton({
  collapsed = true,
  children,
  target = '',
  ariaDetails,
}) {
  const [showChildren, setShowChildren] = useState(!collapsed);

  useEffect(() => {
    setShowChildren(!collapsed);
  }, [collapsed]);

  function handleToggleClick() {
    setShowChildren(!showChildren);
  }

  const detailsText = showChildren ? `Hide ${target}` : `Show ${target}`;
  const ariaLabel = showChildren ? `Hide ${ariaDetails}` : `Show ${ariaDetails}`;

  return (
    <div className={styles.container}>
      <div className={showChildren ? styles.expandedChildren : ''}>
        <Collapsible collapsed={!showChildren}>{children}</Collapsible>
      </div>
      <Button
        small
        primary
        onClick={handleToggleClick}
        className={styles.toggleButton}
        aria-label={ariaLabel}
      >
        {detailsText}
      </Button>
    </div>
  );
}
